import type { DateIso } from '../../types/domain';
import type { HoursByDayAndDev } from './types';

// ── Facturation au réel : jours par personne sur une plage libre (voir tsDailyByPhase) ──────────
// dailyForPhase = tsDailyByPhase[phase.id], { [date]: { [devId]: heures } }, jamais bornée par
// les dates de la phase — c'est la plage [from,to] choisie par qui facture qui filtre, pas le contrat.
export function billingPersonTotals(
  dailyForPhase: HoursByDayAndDev | null | undefined,
  from: DateIso | null | undefined,
  to: DateIso | null | undefined,
): Record<string, number> {
  const totals: Record<string, number> = {};
  for (const date of Object.keys(dailyForPhase || {})) {
    if ((from && date < from) || (to && date > to)) continue;
    const byDev = dailyForPhase![date];
    for (const devId of Object.keys(byDev)) totals[devId] = (totals[devId] || 0) + byDev[devId];
  }
  return totals;
}

export function billingPersonTotalsByMonth(
  dailyForPhase: HoursByDayAndDev | null | undefined,
  from: DateIso | null | undefined,
  to: DateIso | null | undefined,
): Record<string, Record<string, number>> {
  const out: Record<string, Record<string, number>> = {};
  for (const date of Object.keys(dailyForPhase || {})) {
    if ((from && date < from) || (to && date > to)) continue;
    const m = date.slice(0, 7);
    out[m] ||= {};
    const byDev = dailyForPhase![date];
    for (const devId of Object.keys(byDev)) out[m][devId] = (out[m][devId] || 0) + byDev[devId];
  }
  return out;
}

export function sumHours(totals: Record<string, number> | null | undefined): number {
  return Object.values(totals || {}).reduce((s, h) => s + h, 0);
}
